var map = {
	"./english.json": "6f35",
	"./es-ES.json": "4109",
	"./french.json": "8947",
	"./german.json": "de53",
	"./italian.json": "b25d",
	"./portuguese.json": "4da9",
	"./zh-CN.json": "423e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";